<template>
  <Sider style="width: 150px;background: #1f2d3d; height: 100%;">
    <Menu ref="side_menu" v-if="data.length" :active-name="activeName" :open-names="openNames" class="scrollable-menu" theme="dark" width="100%" @on-select="menuChange">
      <Submenu :name="item.id" v-for="(item,index) in data" :key="index">
        <template #title>
          <i class="iconfont" :class="item.thumb"></i>
          {{ item.title }}
        </template>
        <MenuItem :name="items.path" v-for="(items,indexs) in item.children" :key="indexs" :to="'/admin'+items.path">
        {{ items.title }}</MenuItem>
      </Submenu>
    </Menu>
  </Sider>
</template>

<script>
export default {
  data () {
    return {
      activeName: localStorage.getItem('site_active_name') || '',
      openNames: JSON.parse(localStorage.getItem('site_open_names')) || [],
      data: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let _this = this
      this.requestApi('/adm/get_site_menu').then((res) => {
        _this.data = res.data
        if (_this.activeName == '' && res.data.length) {
          localStorage.setItem('site_open_names', JSON.stringify([res.data[0].id]))
          localStorage.setItem('site_active_name', res.data[0].children[0].path)
          _this.activeName = res.data[0].children[0].path
        }
        _this.$nextTick(() => {
          _this.$refs.side_menu.updateOpened()
          _this.$refs.side_menu.updateActiveName()
        })
      })
    },
    // 选中路由
    menuChange (e) {
      localStorage.setItem('site_active_name', e)
      this.activeName = e
      this.updateOpenNames()
    },
    updateOpenNames () {
      const findParent = (items, targetId) => {
        for (const item of items) {
          if (item.children && item.children.some(child => child.path === targetId)) {
            return item.id
          }
          if (item.children) {
            const parentId = findParent(item.children, targetId)
            if (parentId) {
              return parentId
            }
          }
        }
      }

      const parentId = findParent(this.data, this.activeName)
      if (parentId) {
        this.openNames = [parentId]
        localStorage.setItem('site_open_names', JSON.stringify(this.openNames))
      }
    }
  }
}
</script>

<style scoped>
  /* 隐藏滚动条但保留滚动功能 */
  .scrollable-menu {
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge */

    &::-webkit-scrollbar {
      display: none;
      /* Chrome/Safari/Opera */
      width: 0;
      height: 0;
      background: transparent;
    }
  }

  /* 其他保持滚动的核心样式 */

  .scrollable-menu {
    height: 100%;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    /* 流畅滚动 */
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/menu/siteMenu.vue